class Products extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector(".product-grid");
    this.variants = window.variants || [];
    this.allProductsQnt = this.variants.length;
    this.selectedFilters = {};
    this.sortType = "";
    this.initSortDropdown();
    this.qnt = this.querySelector(".all-products-head__quantity .span");
    this.mobileQnt = this.querySelector(
      "#all-filters .mobile-footer .mobile-footer__qnt"
    );
    this.card = false;
    this.itemsPerPage = 40;
    this.inputs = this.querySelectorAll("#all-filters .filter-block input");
    this.isFirstLoad = true;

    const preselectedFiltersData = this.dataset.preselectedFilters;
    if (preselectedFiltersData) {
      try {
        const preselected = JSON.parse(preselectedFiltersData);

        // normalize to arrays
        Object.entries(preselected).forEach(([key, value]) => {
          this.selectedFilters[key] = Array.isArray(value) ? value : [value];
        });
        this.preselectedFilters = {};
        Object.entries(preselected).forEach(([key, value]) => {
          this.preselectedFilters[key] = Array.isArray(value) ? value : [value];
        });

        // visually check matching inputs
        Object.entries(this.selectedFilters).forEach(([category, values]) => {
          values.forEach((val) => {
            const input = this.querySelector(
              `#all-filters input[data-category="${category}"][value="${val}"]`
            );
            if (input) input.checked = true;
          });
        });

        console.log("✅ Preselected filters applied:", this.selectedFilters);
      } catch (err) {
        console.warn("⚠️ Failed to parse preselected filters", err);
      }
    }

    const savedView = localStorage.getItem("gridView");
    if (savedView === "multi") {
      const multiViewInput = this.querySelector(
        '.view-switcher input[value="multi"]'
      );
      if (multiViewInput) {
        multiViewInput.checked = true;
        this.container.classList.add("multi");
      }
    }

    this.querySelectorAll(".view-switcher input").forEach((input) => {
      input.addEventListener("change", this.viewSwitch.bind(this));
    });

    this.querySelector("#all-filters .mobile-footer").addEventListener(
      "click",
      this.mobileFilterClose.bind(this)
    );
    this.querySelector(".mobile-head__wrapper svg").addEventListener(
      "click",
      this.mobileFilterClose.bind(this)
    );
    this.querySelector("#mobile-filter-toggle").addEventListener(
      "click",
      this.mobileFilterOpen.bind(this)
    );
    this.querySelector("#filter-toggle").addEventListener(
      "click",
      this.toggleFilterBlock.bind(this)
    );
    this.querySelector(
      ".used-filters .used-filters__clear.mobile"
    ).addEventListener("click", this.clearAllFilters.bind(this));
    this.querySelector(
      ".used-filters .used-filters__clear.desktop"
    ).addEventListener("click", this.clearAllFilters.bind(this));
  }

  isProductAvailable(item) {
    if (!item) return false;

    // ✅ If it's a grouped card with multiple inner size variants
    if (Array.isArray(item.variants) && item.variants.length > 0) {
      return item.variants.some(
        (v) =>
          v.available === true || v.available === "true" || v.available === 1
      );
    }

    // ✅ If it's a simple product (no inner variants)
    return (
      item.available === true ||
      item.available === "true" ||
      item.available === 1
    );
  }

  isDefaultColorOnly() {
    if (!this.preselectedFilters) return false;

    // remove implicit "category: All"
    const meaningfulSelectedKeys = Object.keys(this.selectedFilters).filter(
      (key) => !(key === "category" && this.selectedFilters[key]?.[0] === "All")
    );

    const meaningfulPreKeys = Object.keys(this.preselectedFilters);

    if (meaningfulPreKeys.length !== 1) return false;
    if (meaningfulPreKeys[0] !== "options") return false;

    if (meaningfulSelectedKeys.length !== 1) return false;
    if (meaningfulSelectedKeys[0] !== "options") return false;

    return true;
  }

  getFirstBadgedVariant(product) {
    // If grouped product (with variants)
    if (Array.isArray(product.variants)) {
      return (
        product.variants.find(
          (v) => Array.isArray(v.badges) && v.badges.length > 0
        ) || null
      );
    }

    // If flat product with badges on itself
    if (Array.isArray(product.badges) && product.badges.length > 0) {
      return product; // treat product itself as the "variant"
    }

    return null;
  }

  toggleFilterBlock() {
    this.querySelector("#filter-toggle").classList.toggle("is-visible");
    this.querySelector("#all-filters").classList.toggle("is-visible");
  }

  connectedCallback() {
    this.initFiltersFromURL();

    document.addEventListener("variants:ready", (e) => {
      console.log(
        "🔹 Variants ready event received:",
        e.detail?.length,
        "variants"
      );
      this.variants = e.detail || [];
      this.allProductsQnt = this.variants.length;
      this.renderVariants();
      setTimeout(() => {
        const skeleton = document.querySelector(".psa_skeleton-out");
        skeleton?.classList.add("loaded");
        skeleton?.classList.add("hided");
        document.querySelector(".product-grid-wrapper").style.minHeight = "unset";
      }, 500);
      this.querySelector("#all-filters .filter-name__qnt.all").innerHTML =
        `(${this.allProductsQnt})`;
    });

    document.addEventListener("DOMContentLoaded", () => {
      const firstCard = document.querySelector(".filter-block__content #card");
      firstCard ? this.updateCard(firstCard) : "";
      this.updateUsedFilters();
      this.renderVariants();
      this.querySelectorAll("#all-filters input").forEach((input) => {
        if (input.dataset.type === "sort") {
          input.onclick = (event) => {
            const type = event.target.dataset.sort;
            const text = event.target.value;
            this.setSortType(type, text);
            this.updateMobileUsed(event.target);
          };

          return;
        }

        input.onclick = (event) => {
          const isRadio =
            event.target.type === "radio" && event.target.name !== "size";
          const matched = event.target.dataset.matched;
          const matchedClosed = event.target.dataset.closed
            ? event.target.dataset.closed
            : "";
          const card = event.target.parentNode.querySelector("#card");

          this.toggleFilter(
            event.target.dataset.category,
            event.target.value,
            isRadio,
            matched,
            matchedClosed !== "" ? matchedClosed : "",
            card ? card : ""
          );
        };
      });

      const firstCheckedInput = this.querySelector(
        '.filter-block__wrapper input[name="category"]:checked'
      );
      this.updateMatched(
        firstCheckedInput?.dataset.matched,
        firstCheckedInput?.dataset.closed
      );

      this.querySelector("#all-filters .filter-name__qnt.all").innerHTML =
        `(${this.allProductsQnt})`;
    });
  }

  initFiltersFromURL() {
    const params = new URLSearchParams(window.location.search);

    // Build list of valid filters from the UI
    const allowedFilters = {};

    this.querySelectorAll("#all-filters input[data-category]").forEach(
      (input) => {
        const category = input.dataset.category;
        const value = input.value;

        if (!category || !value) return;

        if (!allowedFilters[category]) {
          allowedFilters[category] = [];
        }

        if (!allowedFilters[category].includes(value)) {
          allowedFilters[category].push(value);
        }
      }
    );

    // Build list of valid sort values
    const allowedSorts = Array.from(
      document.querySelectorAll(".sort-option[data-sort]")
    ).map((el) => el.dataset.sort);

    this.selectedFilters = this.selectedFilters || {};

    for (const key of params.keys()) {
      // Handle sort
      if (key === "sort") {
        const sortValue = params.get("sort");
        if (!allowedSorts.includes(sortValue)) continue;

        this.sortType = sortValue;

        const sortLabel = document.querySelector(
          `.sort-option[data-sort="${sortValue}"]`
        );
        if (sortLabel) {
          document.querySelector("#sort-selected span").textContent =
            sortLabel.textContent;
        }
        continue;
      }

      // Ignore unknown filter categories
      if (!allowedFilters[key]) continue;

      // Keep only valid filter values
      const validValues = params
        .getAll(key)
        .filter((value) => allowedFilters[key].includes(value));

      if (validValues.length) {
        this.selectedFilters[key] = validValues;
      }
    }

    // Fallback sort
    if (!this.sortType) {
      this.sortType = this.querySelector("#sort-selected")?.dataset.first || "";
    }

    this.updateCheckboxes();
  }

  updateUrlParams() {
    const params = new URLSearchParams();
    for (const [key, values] of Object.entries(this.selectedFilters)) {
      values.forEach((value) => {
        params.append(key, value);
      });
    }
    params.append("sort", this.sortType);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    history.replaceState(null, "", newUrl);
  }

  toggleFilter(
    category,
    value,
    isRadio = false,
    matched = "",
    matchedClosed = "",
    card = false
  ) {
    if (isRadio) {
      this.clearAllFiltersWithoutRender();
      if (value === "All") {
        delete this.selectedFilters[category];
      } else {
        this.selectedFilters[category] = [value];
      }

      if (card) {
        this.updateCard(card);
      } else {
        this.card = false;
      }
      this.updateMatched(matched, matchedClosed);
    } else if (category == "size") {
      if (value === "All") {
        delete this.selectedFilters[category];
      } else {
        this.selectedFilters[category] = [value];
      }
    } else {
      if (!this.selectedFilters[category]) {
        this.selectedFilters[category] = [];
      }

      const index = this.selectedFilters[category].indexOf(value);
      if (index > -1) {
        this.selectedFilters[category].splice(index, 1);
      } else {
        this.selectedFilters[category].push(value);
      }

      if (this.selectedFilters[category].length === 0) {
        delete this.selectedFilters[category];
      }

      if (category == "category") {
        this.updateMatched();
      }
    }

    this.updateUsedFilters();
    this.renderVariants(category);
    this.updateUrlParams();
  }

  toggleSize(category) {
    delete this.selectedFilters[category];
    this.updateUsedFilters();
    this.renderVariants(category);
    this.updateUrlParams();
  }

  updateCard(card) {
    this.card = {
      image: card.dataset.image,
      title: card.dataset.title,
      subtitle: card.dataset.subtitle,
      label: card.dataset.label,
      link: card.dataset.link,
    };
  }

  updateMatched(matched = "", matchedClosed = "") {
    const allMatched = this.querySelector(
      '.filter-block__wrapper input[name="category"][value="All"]'
    );
    let matchedFilters;
    let closedMatchedFilters;

    matched === ""
      ? (matchedFilters = allMatched?.dataset.matched.split(","))
      : (matchedFilters = matched.split(","));
    matchedClosed !== ""
      ? (closedMatchedFilters = matchedClosed.split(","))
      : (closedMatchedFilters = allMatched?.dataset.closed.split(","));

    this.querySelectorAll(
      "#all-filters .filter-block:not(.mobile-sort)"
    ).forEach((filter) => {
      const category = filter.dataset.category;
      const filterDetails = filter.querySelector(".filter-block__details");
      const isClosed = closedMatchedFilters.includes(category);

      if (matchedFilters.includes(category)) {
        filter.classList.remove("hide");
        isClosed
          ? filterDetails.removeAttribute("open")
          : filterDetails.setAttribute("open", "");
      } else {
        filter.classList.add("hide");
      }
    });
  }

  updateUsedFilters() {
    const usedFiltersList = document.querySelector(".used-filters__list");

    // Remove old filter items
    usedFiltersList
      .querySelectorAll(".used-filters__item")
      .forEach((filter) => filter.remove());

    // Rebuild filter items
    for (const category in this.selectedFilters) {
      this.selectedFilters[category].forEach((value) => {
        const filterElement = document.createElement("div");
        filterElement.classList.add("used-filters__item");
        filterElement.textContent = value;

        // ⭐ Add class if this filter came from preselectedFilters
        if (
          this.preselectedFilters &&
          this.preselectedFilters[category] &&
          this.preselectedFilters[category].includes(value)
        ) {
          filterElement.classList.add("notVisibleFilterItem");
        }

        // Clicking removes the filter
        filterElement.addEventListener("click", () => {
          if (category === "size") {
            this.toggleSize(category);
          } else {
            this.toggleFilter(category, value, false);
          }
          this.updateCheckboxes();
        });

        usedFiltersList.appendChild(filterElement);
      });
    }

    // ⭐ After rendering all used filters, decide whether to show the "clear filters" button
    let onlyPreselected = true;

    for (const category in this.selectedFilters) {
      const values = this.selectedFilters[category];

      // If this category was NOT preselected → a new filter was added
      if (!this.preselectedFilters || !this.preselectedFilters[category]) {
        onlyPreselected = false;
        break;
      }

      // If value exists that was NOT preselected → user added a filter
      for (const val of values) {
        if (!this.preselectedFilters[category].includes(val)) {
          onlyPreselected = false;
          break;
        }
      }
    }

    // ⭐ Show/hide the "clear filters" buttons
    const clearButtons = document.querySelectorAll(".used-filters__clear");

    clearButtons.forEach((btn) => {
      if (onlyPreselected) {
        btn.style.display = "none"; // hide the button
      } else {
        btn.style.display = ""; // show the button
      }
    });

    this.updateCheckboxes();
  }

  updateCheckboxes() {
    document.querySelectorAll(".filter-checkbox").forEach((checkbox) => {
      const category = checkbox.dataset.category;
      const value = checkbox.value;

      if (
        (this.selectedFilters[category] &&
          this.selectedFilters[category].includes(value)) ||
        value == "All"
      ) {
        checkbox.checked = true;
      } else {
        checkbox.checked = false;
      }
    });
  }

  clearAllFiltersWithoutRender() {
    this.selectedFilters = JSON.parse(JSON.stringify(this.preselectedFilters));

    this.updateUsedFilters();
  }

  clearAllFilters() {
    this.selectedFilters = JSON.parse(JSON.stringify(this.preselectedFilters));
    this.updateUsedFilters();
    this.updateUrlParams();
    this.renderVariants();
    this.updateMatched();
  }

  setSortType(type, text) {
    this.sortType = type;
    document.querySelector("#sort-selected span").textContent = text;
    this.updateUrlParams();
    this.renderVariants();
  }

  filterVariants() {
    const hasSizeFilter = this.selectedFilters.hasOwnProperty("size");

    /* --------------------------------------------------
     ✅ CASE 1: DEFAULT COLOR → USE SIMPLE GROUPED LOGIC
     -------------------------------------------------- */
    if (!hasSizeFilter && this.isDefaultColorOnly()) {
      return this.variants.filter((variant) => {
        return Object.keys(this.selectedFilters).every((category) => {
          if (category === "options" || category === "size") {
            return variant[category]?.some((v) =>
              this.selectedFilters[category].includes(v)
            );
          } else {
            return this.selectedFilters[category]?.includes(variant[category]);
          }
        });
      });
    }

    /* --------------------------------------------------
     ✅ CASE 2: EVERYTHING ELSE → KEEP CURRENT LOGIC
     -------------------------------------------------- */

    // existing logic (UNCHANGED)
    const filteredBase = this.variants.filter((product) => {
      return Object.keys(this.selectedFilters)
        .filter((key) => key !== "size")
        .every((category) => {
          if (category === "options") {
            return product[category]?.some((opt) =>
              this.selectedFilters[category].includes(opt)
            );
          } else {
            return this.selectedFilters[category]?.includes(product[category]);
          }
        });
    });

    const shouldExpandBySize = !hasSizeFilter;

    if (shouldExpandBySize) {
      const expanded = [];

      filteredBase.forEach((product) => {
        if (Array.isArray(product.variants) && product.variants.length > 0) {
          product.variants.forEach((v) => {
            expanded.push({
              ...product,
              image_url: v.image_url,
              variant_title: v.variant_title,
              price_sort: parseFloat(v.variant_price.replace(/[^\d,.]/g, "")),
              sale: v.sale,
              sale_euro: v.sale_euro,
              available: v.available,
              badges: v.badges,
              url: v.variant_link,
              variants: [v],
            });
          });
        } else {
          expanded.push(product);
        }
      });

      return expanded;
    }

    if (hasSizeFilter) {
      return filteredBase.filter((product) =>
        product.variants?.some((v) =>
          this.selectedFilters.size.includes(v.variant_title)
        )
      );
    }

    return filteredBase;
  }

  filterVariantsQnt(qntFilters) {
    const map = new Map(); // productId → product
  
    this.variants.forEach((variant) => {
      const matches = Object.keys(qntFilters).every((category) => {
        if (category === "options") {
          return variant.options?.some(opt =>
            qntFilters.options.includes(opt)
          );
        }
  
        if (category === "size") {
          return variant.variants?.some(v =>
            qntFilters.size.includes(v.variant_title)
          );
        }
  
        return qntFilters[category]?.includes(variant[category]);
      });
  
      if (matches) {
        map.set(variant.id, variant); // 🔑 UNIQUE per product
      }
    });
  
    return Array.from(map.values());
  }
  
  
  

  sortVariants(filteredVariants) {
    return filteredVariants.sort((a, b) => {
      // ✅ always push sold-out products to bottom regardless of sorting type
      const aAvailable = this.isProductAvailable(a);
      const bAvailable = this.isProductAvailable(b);
      if (aAvailable && !bAvailable) return -1;
      if (!aAvailable && bAvailable) return 1;

      // all other existing sort rules remain unchanged
      if (this.sortType === "price-high-low") {
        if (this.selectedFilters["size"]) {
          const getProductPrice = (product) => {
            if (product.variants) {
              const variant = product.variants.find(
                (v) => v.variant_title === this.selectedFilters["size"][0]
              );
              if (variant) {
                return parseFloat(variant.variant_price.split(" ")[0]) * 100;
              }
            }
            return product.price_sort;
          };
          const aPrice = getProductPrice(a);
          const bPrice = getProductPrice(b);
          return bPrice - aPrice;
        } else {
          return b.price_sort - a.price_sort;
        }
      } else if (this.sortType === "price-low-high") {
        if (this.selectedFilters["size"]) {
          const getProductPrice = (product) => {
            if (product.variants) {
              const variant = product.variants.find(
                (v) => v.variant_title === this.selectedFilters["size"][0]
              );
              if (variant) {
                return parseFloat(variant.variant_price.split(" ")[0]) * 100;
              }
            }
            return product.price_sort;
          };
          const aPrice = getProductPrice(a);
          const bPrice = getProductPrice(b);
          return aPrice - bPrice;
        } else {
          return a.price_sort - b.price_sort;
        }
      } else if (this.sortType === "newest") {
        const getNewestPriority = (product) => {
          if (product.variants && product.variants.length > 0) {
            return Math.max(...product.variants.map((v) => v.variant_newest));
          }
          return -Infinity;
        };
        const aPriority = getNewestPriority(a);
        const bPriority = getNewestPriority(b);
        return bPriority - aPriority;
      } else if (this.sortType === "sale") {
        const getMaxSale = (product) => {
          if (Array.isArray(product.variants)) {
            return Math.max(
              ...product.variants.map((v) => parseFloat(v.sale) || 0)
            );
          }
          return parseFloat(product.sale) || 0;
        };
        return getMaxSale(b) - getMaxSale(a);
      } else if (this.sortType === "sale_euro") {
        const getMaxSaleEuro = (product) => {
          if (Array.isArray(product.variants)) {
            return Math.max(
              ...product.variants.map((v) => parseFloat(v.sale_euro) || 0)
            );
          }
          return parseFloat(product.sale_euro) || 0;
        };
        return getMaxSaleEuro(b) - getMaxSaleEuro(a);
      } else {
        // default sorting (e.g., bestseller)
        const aBadge = this.getFirstBadgedVariant(a);
        const bBadge = this.getFirstBadgedVariant(b);
        if (aBadge && !bBadge) return -1;
        if (!aBadge && bBadge) return 1;
        return 0;
      }
    });
  }

  initSortDropdown() {
    const dropdown = document.getElementById("sort-dropdown");
    const dropdownToggle = document.getElementById("sort-selected");
    dropdownToggle.onclick = () => dropdown.classList.toggle("open");

    document.querySelectorAll(".sort-option").forEach((option) => {
      option.onclick = (event) => {
        const type = event.target.dataset.sort;
        const text = event.target.textContent;
        document
          .querySelector(".dropdown-menu .sort-option.sort-selected")
          ?.classList.remove("sort-selected");
        event.target.classList.add("sort-selected");
        this.setSortType(type, text);
        dropdown.classList.remove("open");
      };
    });

    document.addEventListener("click", (event) => {
      if (!dropdown.contains(event.target)) {
        dropdown.classList.remove("open");
      }
    });
  }

  updateQntFilters() {
    this.inputs.forEach((input) => {
      this.updateMobileUsed(input);
      if (input.type === "radio" && input.name !== "size") return;
      if (input.type === "hidden") return;
  
      const category = input.dataset.category;
      const value = input.value;
  
      // Case: input already checked → count only that filter
      if (input.checked) {
        // For options (frame color): show full result count
        if (category === "options") {
          const count = this.filterVariantsQnt(this.selectedFilters).length;
          this.updateInput(input, count);
          return;
        }
      
        // For all other categories (e.g. tabletop color):
        // simulate ONLY this value
        const qntFilters = JSON.parse(JSON.stringify(this.selectedFilters));
        qntFilters[category] = [value];
      
        const count = this.filterVariantsQnt(qntFilters).length;
        this.updateInput(input, count);
        return;
      }
      
      
  
      // Case: input not checked → simulate adding it
      const qntFilters = JSON.parse(JSON.stringify(this.selectedFilters));

      // 🔑 REMOVE current category before counting
      if (qntFilters[category]) {
        delete qntFilters[category];
      }

  
      if (!qntFilters[category] || category === "size") {
        qntFilters[category] = [];
      }
  
      if (!qntFilters[category].includes(value)) {
        qntFilters[category].push(value);
      }
  
      // Special case: All
      if (value === "All") {
        delete qntFilters.size;
      }
  
      const count = this.filterVariantsQnt(qntFilters).length;
      this.updateInput(input, count);
    });
  }
  

  updateInput(input, count) {
    const parentElement = input.closest(".filter-item");
    if (!parentElement) return;

    const qntElement = parentElement.querySelector(".filter-name__qnt");
    if (qntElement) {
      qntElement.textContent = `(${count})`;
    }

    // ✅ Hide color bubbles if count is 0 and category is not "All" or "Desks"
    const currentCategory =
      this.selectedFilters["category"] &&
      this.selectedFilters["category"][0]?.toLowerCase();

    if (
      input.dataset.category === "options" &&
      currentCategory &&
      currentCategory !== "all" &&
      !currentCategory.includes("desk")
    ) {
      if (count === 0) {
        parentElement.style.display = "none";
      } else {
        parentElement.style.display = "";
      }
    } else {
      // Always show when “All” or “Desks” are selected
      parentElement.style.display = "";
    }
  }

  updateMobileUsed(input) {
    if (input.value == "All") return;
    const filterBlock = input.closest(".filter-block");
    if (!filterBlock) return;

    const usedBlock = filterBlock.querySelector(".filter-block__used");
    if (!usedBlock) return;

    let values = usedBlock.textContent.split(", ").filter(Boolean);

    if (input.checked) {
      if (!values.includes(input.value)) {
        values.push(input.value);
      }
    } else {
      values = values.filter((val) => val !== input.value);
    }

    usedBlock.textContent = values.join(", ");
  }

  optionClick(event) {
    event.preventDefault();
    const link = event.currentTarget.getAttribute("href");
    if (link) {
      window.location.href = link;
    }
  }

  optionHover(event) {
    const imageAlt = event.currentTarget.getAttribute("data-alt");

    if (imageAlt) {
      const parentImageLink = event.currentTarget.closest(
        ".product-item__image"
      );
      const images = parentImageLink?.querySelectorAll("img");
      images.forEach((image) => {
        if (image.alt === imageAlt) {
          image.classList.add("active-hover");
        } else {
          image.classList.remove("active-hover");
        }
      });
    }

    const priceBlock = event.currentTarget.getAttribute("data-price");
    const priceBlockCompare = event.currentTarget.getAttribute("data-compare");

    if (priceBlock) {
      const priceBlockVisible = event.currentTarget
        .closest(".product-item")
        .querySelector(".price-block--hidden");
      priceBlockVisible.querySelector(".price-block__price").textContent =
        priceBlock;
      priceBlockVisible.querySelector(".price-block__compare").textContent =
        priceBlockCompare;
      event.currentTarget
        .closest(".product-item")
        .querySelector(".price-block--visible")
        .classList.add("hidden");
      event.currentTarget
        .closest(".product-item")
        .querySelector(".price-block--hidden")
        .classList.remove("hidden");
    }
  }

  optionHoverLeave(event) {
    const parentImageLink = event.target;

    if (parentImageLink) {
      const images = parentImageLink.querySelectorAll("img");
      images.forEach((img) => img.classList.remove("active-hover"));
    }

    const priceBlockVisible = event.currentTarget
      .closest(".product-item")
      .querySelector(".price-block--hidden");
    priceBlockVisible.querySelector(".price-block__price").textContent = "";
    priceBlockVisible.querySelector(".price-block__compare").textContent = "";
    event.currentTarget
      .closest(".product-item")
      .querySelector(".price-block--visible")
      .classList.remove("hidden");
    event.currentTarget
      .closest(".product-item")
      .querySelector(".price-block--hidden")
      .classList.add("hidden");
  }

  appendDefaultSizeToTitles() {
    // must have a preselected size
    if (
      !this.preselectedFilters ||
      !this.preselectedFilters.size ||
      !this.preselectedFilters.size.length
    ) {
      return;
    }

    // only apply if user didn't change size
    const currentSize = this.selectedFilters.size;
    const defaultSize = this.preselectedFilters.size[0];

    if (!currentSize || currentSize[0] !== defaultSize) return;

    // ensure size filter is hidden (default-only behavior)
    const sizeFilterBlock = this.querySelector(
      '.filter-block[data-category="size"]'
    );
    if (sizeFilterBlock && sizeFilterBlock.offsetParent !== null) return;

    // append size to titles
    this.querySelectorAll(".product-item__title").forEach((title) => {
      // prevent double-append
      if (title.dataset.sizeAppended === "true") return;

      title.innerHTML += ` / ${defaultSize}`;
      title.dataset.sizeAppended = "true";
    });
  }

  renderVariants() {
    if (!this.container) return;

    let filtered = this.filterVariants();
    filtered = this.sortVariants(filtered);
    // console.log(`🔹 Sorted by: ${this.sortType}`, filtered);

    // console.table(
    //   filtered.map(v => ({
    //     product_title: v.product_title,
    //     color_group: v.color_group || '',
    //     sale_euro: v.variants && v.variants.length > 0
    //       ? v.variants[0].sale_euro
    //       : v.sale_euro
    //   }))
    // );

    console.table(
      filtered.map((product) => {
        const firstBadged = this.getFirstBadgedVariant(product);
        return {
          product_title: product.product_title,
          color_group: product.color_group || "",
          has_bestseller: !!firstBadged,
        };
      })
    );

    filtered.forEach((p) => {
      if (
        p.product_title.includes("Kabelkanal") ||
        p.product_title.includes("Cable")
      ) {
        console.log(
          "🔍 Inspecting badges for",
          p.product_title,
          this.getFirstBadgedVariant(p)
        );
      }
    });

    this.updateQntFilters();

    this.qnt.innerHTML = filtered.length;
    let extraCount = 0;
    let nextInsertIndex = 8;

    this.container.innerHTML = filtered
      .map((variant, index) => {
        let extraItem = "";

        if (this.card && index + 1 === nextInsertIndex) {
          extraItem = `
            <li class="product-item card">
              <a class="card__wrapper" href="${this.card.link}">
                <div class="card__text">                
                  <h4 class="card__title">${this.card.title}</h4>
                  <p class="card__subtitle">${this.card.subtitle}</p>
                  <div class="card__button">
                    <span class="card__label">${this.card.label}</span>
                    ${
                      this.card.label !== ""
                        ? `<svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 1L5 5.5L1 10" stroke="#EFEEE9" />
                        </svg>`
                        : ``
                    }
                  </div>
                </div>
                <div class="card__overlay"></div>
                <img class="card__image" src="${window.location.origin}/cdn/shop/${this.card.image}" alt="${this.card.title}">
              </a>
            </li>
          `;
          extraCount++;
          nextInsertIndex += 8 + extraCount;
        }

        if (variant.color_group) {
          let priceRange;

          // ✅ If only one variant (like when no size is selected and cards are expanded)
          if (variant.variants.length === 1) {
            const v = variant.variants[0];
            priceRange = `
                <span class="price-block__price onSale" data-variant-id="${v.variant_idx || v.id}">
                ${v.variant_price}
                </span>
                ${
                  v.variant_compare_price
                    ? `<span class="price-block__compare" data-variant-id="${v.variant_idx || v.id}">
                        ${v.variant_compare_price}
                    </span>`
                    : ""
                }
            `;
          } else {
            // ✅ Fallback: show range for grouped products
            const prices = variant.variants.map((v) =>
              parseFloat(v.variant_price.replace(/[^\d,.]/g, ""))
            );
            const samplePrice = variant.variants[0].variant_price.trim();
            const currencyBefore = /^[^\d]/.test(samplePrice);
            const currencySymbol = samplePrice.replace(/[\d.,\s]/g, "").trim();
            const hasSpace =
              /\d\s[^\d]/.test(samplePrice) || /[^\d]\s\d/.test(samplePrice);
            const space = hasSpace ? " " : "";

            // Get the variant id of the cheapest variant and the most expensive one, from the variant_id variable
            const cheapestVariantId = variant.variants[prices.indexOf(Math.min(...prices))].variant_id;
            const mostExpensiveVariantId = variant.variants[prices.indexOf(Math.max(...prices))].variant_id;
            // Extract only numeric values from cheapestVariantId and mostExpensiveVariantId
            const cheapestVariantIdNumeric = cheapestVariantId.replace(/\D/g, "");
            const mostExpensiveVariantIdNumeric = mostExpensiveVariantId.replace(/\D/g, "");

            priceRange = currencyBefore
              ? `${currencySymbol}${space}${Math.min(...prices)} - ${currencySymbol}${space}${Math.max(...prices)}`
              : `${Math.min(...prices)}${space}${currencySymbol} - ${Math.max(...prices)}${space}${currencySymbol}`;
          }

          // const prices = variant.variants.map((v) => {
          //   return parseFloat(v.variant_price.replace(/[^\d.]/g, ""));
          // });
          // const currencySymbol = variant.variants[0].variant_price
          //   .replace(/[\d.]/g, "")
          //   .trim();
          // const priceRange = `${Math.min(...prices)} ${currencySymbol} - ${Math.max(...prices)} ${currencySymbol}`;

          return `
            <li class="product-item" data-index="${index}">
              <a 
                class="product-item__image color_group" 
                href="${
                  this.selectedFilters.size
                    ? variant.variants.find(
                        (v) => v.variant_title === this.selectedFilters.size[0]
                      )?.variant_link || variant.url
                    : variant.url
                }
                ">
                ${variant.variants
                  .map((option, index) => {
                    const isActive = this.selectedFilters.size
                      ? option.variant_title === this.selectedFilters.size[0]
                      : option.variant_title === variant.basic_color
                        ? true
                        : index === 0;
                    return `<img ${isActive ? `class="active"` : ""} loading="lazy" src="${window.location.origin}/cdn/shop/${option.image_url}" alt="${option.variant_title}">`;
                  })
                  .join("")}
                ${
                  !this.isProductAvailable(variant)
                    ? `<div class="badge-sold">${this.dataset.soldBadge}</div>`
                    : `<div class="badges-block">
                      ${
                        this.selectedFilters.size
                          ? `
                        ${(() => {
                          const selectedVariant = variant.variants.find(
                            (v) =>
                              v.variant_title === this.selectedFilters.size[0]
                          );
                          return selectedVariant
                            ? selectedVariant.badges
                                .map(
                                  (badge) => `
                            <div class="badge-basic">
                              <span>${badge.name}</span>
                            </div>
                          `
                                )
                                .join("")
                            : "";
                        })()}
                      `
                          : (() => {
                              const firstVariantWithBadges =
                                variant.variants.find(
                                  (v) => v.badges && v.badges.length > 0
                                );
                              return firstVariantWithBadges
                                ? firstVariantWithBadges.badges
                                    .map(
                                      (badge) => `
                          <div class="badge-basic">
                            <span>${badge.name}</span>
                          </div>
                        `
                                    )
                                    .join("")
                                : "";
                            })()
                      }
  
                      ${(() => {
                        let selectedVariant;
                        let saleBadge = this.dataset.saleBadge;
                        if (this.selectedFilters.size) {
                          selectedVariant = variant.variants.find(
                            (v) =>
                              v.variant_title === this.selectedFilters.size[0]
                          );
                        } else {
                          saleBadge = this.dataset.saleAllBadge;
                          selectedVariant = variant.variants.reduce(
                            (max, current) => {
                              const currentSale = current.sale || 0;
                              const maxSale = max.sale || 0;
                              return currentSale > maxSale ? current : max;
                            }
                          );
                        }
                        return selectedVariant && selectedVariant.sale > 0
                          ? `
                            <div class="badge-sale">
                              <span>${saleBadge.includes("|") ? saleBadge.replace("|", selectedVariant.sale + "%") : `${saleBadge} ${selectedVariant.sale}%`}</span>
                            </div>
                          `
                          : "";
                      })()}
                      </div>
                    `
                }
              </a>
              <div class="product-item__info">
                ${
                  variant.rating != ""
                    ? `
                  <div class="ruk_rating_snippet" data-sku="${variant.id}">
                  <span>
                    <svg width="63" height="10" viewBox="0 0 63 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.25731 0L6.75844 3.46174L10.5146 3.81966L7.68619 6.31705L8.50651 10L5.25731 8.08174L2.00811 10L2.82843 6.31705L0 3.81966L3.75618 3.46174L5.25731 0Z" fill="#E2AE44"/>
                      <path d="M18.3042 0L19.8053 3.46174L23.5615 3.81966L20.7331 6.31705L21.5534 10L18.3042 8.08174L15.055 10L15.8753 6.31705L13.0469 3.81966L16.8031 3.46174L18.3042 0Z" fill="#E2AE44"/>
                      <path d="M31.3432 0L32.8444 3.46174L36.6006 3.81966L33.7721 6.31705L34.5924 10L31.3432 8.08174L28.0941 10L28.9144 6.31705L26.0859 3.81966L29.8421 3.46174L31.3432 0Z" fill="#E2AE44"/>
                      <path d="M44.3901 0L45.8913 3.46174L49.6474 3.81966L46.819 6.31705L47.6393 10L44.3901 8.08174L41.1409 10L41.9612 6.31705L39.1328 3.81966L42.889 3.46174L44.3901 0Z" fill="#E2AE44"/>
                      <path d="M57.4292 0L58.9303 3.46174L62.6865 3.81966L59.8581 6.31705L60.6784 10L57.4292 8.08174L54.18 10L55.0003 6.31705L52.1719 3.81966L55.9281 3.46174L57.4292 0Z" fill="#E2AE44"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M57.4297 8.08185V0.000976562L58.9303 3.46156L62.6865 3.81948L59.8581 6.31687L60.6784 9.99982L57.4297 8.08185Z" fill="#CCCCCC"/>
                    </svg> 
                  </span>
                  <span class="product-item__count">${variant.rating}</span>
                </div>
                `
                    : ""
                }
                <a class="product-item__link" href="${
                  this.selectedFilters.size
                    ? variant.variants.find(
                        (v) => v.variant_title === this.selectedFilters.size[0]
                      )?.variant_link
                    : variant.variants.find(
                        (v) => v.variant_title === variant.basic_color
                      )?.variant_link || variant.url
                }">
                  <h3 class="product-item__title">${this.dataset.showCustomNamings === 'true' && variant.collection_name ? variant.collection_name : variant.product_title}</br>${variant.color_group.replaceAll("/", " + ")}</h3>
                </a>
                <p class="product-item__variants">${variant.variants.length} ${this.dataset.availableText}</p>
                <div class="price-block price-block--visible">
                  ${
                    this.selectedFilters.size
                      ? (() => {
                          const selectedSize = this.selectedFilters.size[0];
                          const matchingVariant = variant.variants.find(
                            (v) => v.variant_title === selectedSize
                          );
                          return matchingVariant
                            ? `<span class="price-block__price onSale igPrice" data-variant-id="${matchingVariant.variant_id.replace(/\D/g, '')}">${matchingVariant.variant_price}</span>
                        ${matchingVariant.variant_compare_price ? `<span class="price-block__compare " data-variant-id="${matchingVariant.variant_id.replace(/\D/g, '')}">${matchingVariant.variant_compare_price}</span>` : ""}`
                            : (() => {
                                const fallbackVariant =
                                  variant.variants.find(
                                    (v) =>
                                      v.variant_title === variant.basic_color
                                  ) || variant.variants[0];
                                return `<span class="price-block__price">${priceRange}</span>`;
                              })();
                        })()
                      : (() => {
                          const fallbackVariant =
                            variant.variants.find(
                              (v) => v.variant_title === variant.basic_color
                            ) || variant.variants[0];
                          return `<span class="price-block__price">${priceRange}</span>`;
                        })()
                  }
                </div>
                <div class="price-block price-block--hidden hidden">
                  <span class="price-block__price onSale" data-variant-id="${variant.id}"></span>
                  <span class="price-block__compare" data-variant-id="${variant.id}"></span>
                </div>
              </div>
            </li>
            ${extraItem}
          `;
        }

        return `
          <li class="product-item" data-index="${index}">
            <a class="product-item__image" href="${variant.url}">
              <img class="active" src="${window.location.origin}/cdn/shop/${variant.image_url}" alt="${variant.title}">
              ${
                !this.isProductAvailable(variant)
                  ? `<div class="badge-sold">${this.dataset.soldBadge}</div>`
                  : `<div class="badges-block">
                    ${variant.badges
                      .map(
                        (badge) => `
                      <div class="badge-basic">
                        <span>${badge.name}</span>
                      </div>
                    `
                      )
                      .join("")}
                    ${
                      variant.sale > 0
                        ? `
                      <div class="badge-sale">
                        <span>${this.dataset.saleBadge}</span>
                        <span>${variant.sale}%</span>
                      </div>
                    `
                        : ""
                    }
                  </div>`
              }
            </a>
            <div class="product-item__info">
              ${
                variant.rating != ""
                  ? `
                <div class="ruk_rating_snippet" data-sku="${variant.id}">
                  <span>
                    <svg width="63" height="10" viewBox="0 0 63 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.25731 0L6.75844 3.46174L10.5146 3.81966L7.68619 6.31705L8.50651 10L5.25731 8.08174L2.00811 10L2.82843 6.31705L0 3.81966L3.75618 3.46174L5.25731 0Z" fill="#E2AE44"/>
                      <path d="M18.3042 0L19.8053 3.46174L23.5615 3.81966L20.7331 6.31705L21.5534 10L18.3042 8.08174L15.055 10L15.8753 6.31705L13.0469 3.81966L16.8031 3.46174L18.3042 0Z" fill="#E2AE44"/>
                      <path d="M31.3432 0L32.8444 3.46174L36.6006 3.81966L33.7721 6.31705L34.5924 10L31.3432 8.08174L28.0941 10L28.9144 6.31705L26.0859 3.81966L29.8421 3.46174L31.3432 0Z" fill="#E2AE44"/>
                      <path d="M44.3901 0L45.8913 3.46174L49.6474 3.81966L46.819 6.31705L47.6393 10L44.3901 8.08174L41.1409 10L41.9612 6.31705L39.1328 3.81966L42.889 3.46174L44.3901 0Z" fill="#E2AE44"/>
                      <path d="M57.4292 0L58.9303 3.46174L62.6865 3.81966L59.8581 6.31705L60.6784 10L57.4292 8.08174L54.18 10L55.0003 6.31705L52.1719 3.81966L55.9281 3.46174L57.4292 0Z" fill="#E2AE44"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M57.4297 8.08185V0.000976562L58.9303 3.46156L62.6865 3.81948L59.8581 6.31687L60.6784 9.99982L57.4297 8.08185Z" fill="#CCCCCC"/>
                    </svg> 
                  </span>
                  <span class="product-item__count">${variant.rating}</span>
                </div>
                `
                  : ""
              }
  
              <a class="product-item__link" href="${variant.url}">
                <h3 class="product-item__title">${this.dataset.showCustomNamings === 'true' && variant.collection_name ? variant.collection_name : variant.product_title}</h3>
              </a>
              <p class="product-item__variants">${variant.description}</p>
              <div class="price-block">
                <span class="price-block__price ${variant.compare && variant.compare !== "" ? "onSale" : ""}" data-variant-id="${variant.id}">${variant.price}</span>
                ${variant.compare && variant.compare !== "" ? `<span class="price-block__compare" data-variant-id="${variant.id}">${variant.compare}</span>` : ""}
              </div>
            </div>
          </li>
          ${extraItem}
        `;
      })
      .join("");

    // Pagination
    const itemsPerPage = 36;
    const totalPages = Math.ceil(filtered.length / itemsPerPage);
    let currentPage = 0;

    function generatePagination() {
      let paginationHTML = `
          <button class="pagination-prev" disabled>
            <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.5 14L1 7.5L7.5 1" stroke="#19191C" />
            </svg>
          </button>
        `;
      let pages = [];

      if (totalPages <= 5) {
        for (let i = 0; i < totalPages; i++) {
          pages.push(i);
        }
      } else {
        if (currentPage <= 3) {
          pages = [0, 1, 2, 3, "...", totalPages - 1];
        } else if (currentPage >= totalPages - 4) {
          pages = [
            0,
            "...",
            totalPages - 4,
            totalPages - 3,
            totalPages - 2,
            totalPages - 1,
          ];
        } else {
          pages = [
            0,
            "...",
            currentPage - 1,
            currentPage,
            currentPage + 1,
            "...",
            totalPages - 1,
          ];
        }
      }

      paginationHTML += pages
        .map((page) =>
          page === "..."
            ? `<span class="pagination-dots">...</span>`
            : `<button class="pagination-btn" data-page="${page}">${page + 1}</button>`
        )
        .join("");

      paginationHTML += `
          <button class="pagination-next">
            <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L7.5 7.5L1 14" stroke="#19191C" />
            </svg>
          </button>
        `;

      document.querySelector(".pagination")?.remove();
      document
        .querySelector(".product-grid")
        .insertAdjacentHTML(
          "afterend",
          `<div class="pagination">${paginationHTML}</div>`
        );
    }

    function updatePagination(page, isFirstLoad = false) {
      if (!isFirstLoad) scrollToTop();
      currentPage = page;
      document.querySelectorAll(".product-item").forEach((item, index) => {
        item.style.display =
          index >= page * itemsPerPage && index < (page + 1) * itemsPerPage
            ? "block"
            : "none";
      });
      generatePagination();
      document.querySelectorAll(".pagination-btn").forEach((btn) => {
        btn.classList.toggle("active", parseInt(btn.dataset.page) === page);
        btn.addEventListener("click", () =>
          updatePagination(parseInt(btn.dataset.page))
        );
      });
      document.querySelector(".pagination-prev").disabled = page === 0;
      document.querySelector(".pagination-next").disabled =
        page === totalPages - 1;
      document
        .querySelector(".pagination-prev")
        .addEventListener("click", () => updatePagination(currentPage - 1));
      document
        .querySelector(".pagination-next")
        .addEventListener("click", () => updatePagination(currentPage + 1));
    }

    updatePagination(0, this.isFirstLoad);

    // update mobile qnt selected filters
    const usedFiltersList = document.querySelector(".used-filters__list");
    const filteredQnt = document.querySelector("#filtered-mobile-qnt");
    if (usedFiltersList && filteredQnt) {
      const count = usedFiltersList.children.length - 1;
      filteredQnt.textContent = count > 0 ? `${count}` : "";
    }

    // update mobile qnt selected products
    this.allProductsQnt != filtered.length
      ? (this.mobileQnt.innerHTML = `(${filtered.length})`)
      : (this.mobileQnt.innerHTML = "");

    // scroll to top
    if (!this.isFirstLoad) scrollToTop();

    this.appendDefaultSizeToTitles();

    this.isFirstLoad = false;

    function scrollToTop() {
      const section = document.querySelector(".all-products");

      if (section) {
        const top = section.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top, behavior: "smooth" });
      }
    }

    this.querySelectorAll("#color-group-option").forEach((option) => {
      option.addEventListener("click", (event) => this.optionClick(event));
      option.addEventListener("mouseenter", (event) => this.optionHover(event));
    });

    this.querySelectorAll(".product-item__image").forEach((productItem) => {
      productItem.addEventListener("mouseleave", (event) =>
        this.optionHoverLeave(event)
      );
    });
  }

  viewSwitch(event) {
    this.container.classList.toggle("multi");
    localStorage.setItem(
      "gridView",
      this.container.classList.contains("multi") ? "multi" : "single"
    );
  }

  mobileFilterOpen() {
    const allFilters = this.querySelector("#all-filters");
    allFilters.classList.add("is-visible");

    const overlay = document.createElement("div");
    overlay.classList.add("overlay");
    allFilters.parentNode.insertBefore(overlay, allFilters);

    document.body.classList.add("overflow-hidden");
  }

  mobileFilterClose() {
    const allFilters = this.querySelector("#all-filters");
    allFilters.classList.remove("is-visible");
    document.body.classList.remove("overflow-hidden");
    this.querySelector(".all-products-body .overlay").remove();
  }
}

customElements.define("all-products", Products);
